<main>
  <section class="bienvenido-group">
    <img *ngIf="false" src="assets/images/sodimac-stock-here.png" alt="sodimac stock" class="bienvenido-group__sodimac-stock">

    <article class="searcher-group">
      <h5>Búsqueda</h5>
      <form [formGroup]="searchForm" class="">
        <pgs-custom-select formControlName="searchBy" [options]="options" [style.width]="'182px'">
          <!--<option *ngFor="let option of options" [value]="option.value">{{ option.title }}</option>-->
        </pgs-custom-select>
        <input formControlName="searchValue" class="buscar form-control" type="text" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" placeholder="Ingresa tu búsqueda">
        <input [routerLink]="['/proyectos/buscar', searchForm.value]" type="image" src="../../../../assets/images-carousel/icon-search.png" class="image_buscar"/>
      </form>
    </article>



    <article class="carousel-group">
      <div id="carouselExampleIndicators" class="carousel slide" data-bs-ride="carousel">
        <div class="carousel-indicators">
          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active" aria-current="true" aria-label="Slide 1"></button>
          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1" aria-label="Slide 2"></button>
          <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="2" aria-label="Slide 3"></button>
        </div>
        <div class="carousel-inner">
          <div class="carousel-item active">
            <img src="assets/images-carousel/Carrusel-1.jpg" class="d-block w-100" alt="...">
          </div>
          <div class="carousel-item">
            <img src="assets/images-carousel/Carrusel-2.jpg" class="d-block w-100" alt="...">
          </div>
          <div class="carousel-item">
            <img src="assets/images-carousel/Carrusel-3.jpg" class="d-block w-100" alt="...">
          </div>
        </div>
        <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="prev">
          <!-- <span class="carousel-control-prev-icon" aria-hidden="true"></span> -->
          <span class="material-icons">arrow_back_ios</span>
          <span class="visually-hidden"></span>
        </button>
        <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide="next">
          <!-- <span class="carousel-control-next-icon" aria-hidden="true"></span> -->
          <span class="material-icons outlined">arrow_forward_ios</span>
          <span class="visually-hidden"></span>
        </button>
      </div>

      <div class="welcome-group">
        <h1>¡Bienvenid@!</h1>
        <h4>Ya estás dentro de la Plataforma de Gestión de Servicios (PGS)</h4>
        <p>
          Para que nuestros clientes puedan disfrutar de su hogar, ayudaremos en las reparaciones,
          mantenciones e instalaciones con nuestras manos expertas.
        </p>
        <button class="btn btn-danger boton" routerLink="/proyectos/ventas">Ir a venta de proyecto</button>
      </div>
    </article>
  </section>

  <section *ngIf="false" class="contenido-group">
    <h5 class="contenido-group__title">Configura tu contenido</h5>

    <nav class="contenido-group__nav">
      <button>
        <p routerLink="/mantenedor/clientes">Mantenedor/<br />Clientes</p>
        <div>
          <i class="star"></i>
          <i class="delete"></i>
        </div>
      </button>

      <button>
        <p routerLink="/proyectos/buscar">Proyectos/<br />Búsqueda</p>
        <div>
          <i class="star"></i>
          <i class="delete"></i>
        </div>
      </button>

      <button>
        <p routerLink="/proyectos/ventas">Proyectos/<br />Ventas</p>
        <div>
          <i class="star"></i>
          <i class="delete"></i>
        </div>
      </button>

      <button>
        <p></p>
        <div>
          <i class="star"></i>
          <i class="delete"></i>
        </div>
      </button>

      <button>
        <p></p>
        <div>
          <i class="star"></i>
          <i class="delete"></i>
        </div>
      </button>
    </nav>

    <div class="contenido-group__content">
      <!-- <article class="contenido-group__content__advertisements"> -->
      <table class="contenido-group__content__advertisements">
        <thead>
          <i><span>{{ advertisements.length }}</span></i>
          <h6>Anuncios PGS</h6>
        </thead>
        <tbody>
          <tr *ngFor="let advertisement of advertisements">
            <th><title>{{ advertisement.title }}</title> <span>{{ advertisement.ago }}</span></th>
            <td><p>{{ advertisement.paragraph }}</p> <span></span></td>
          </tr>
        </tbody>
      </table>
      <!-- </article> -->

      <aside class="contenido-group__content__others">
        <article><h5>Manuales</h5></article>
        <article><h5>Contacto</h5></article>
      </aside>
    </div>
  </section>
</main>


